import { MarketCountryCode } from '@axo/shared/types';
import { UnfilteredConditionalArray } from '../../../../ConditionalWrappers/types';
import { ApplicationConditionalContext } from '../../../../ConditionalWrappers/useApplicationConditionalContext';
import { useApplicationConditionalFilter } from '../../../../ConditionalWrappers/useApplicationConditionalFilter';
import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(en);

const blacklistedCountryCodes = ['AX'];

const unfilteredCitizenshipOptions: UnfilteredConditionalArray<
  ApplicationConditionalContext,
  { value: string | null; label?: string }
> = [
  {
    value: { value: null, label: '-' },
  },
  {
    value: { value: 'EU' },
    whitelist: [
      {
        marketCountry: [MarketCountryCode.Denmark],
      },
    ],
  },
  {
    value: { value: 'Nordic' },
    whitelist: [
      {
        marketCountry: [MarketCountryCode.Denmark],
      },
    ],
  },
  {
    value: { value: 'DK', label: 'Denmark (DK)' },
    whitelist: [
      {
        marketCountry: [MarketCountryCode.Denmark],
      },
    ],
  },
  {
    value: { value: 'Other' },
    whitelist: [
      {
        marketCountry: [MarketCountryCode.Denmark],
      },
    ],
  },
  ...Object.keys(countries.getAlpha2Codes())
    .filter((code) => !blacklistedCountryCodes.includes(code))
    .map((code) => ({
      value: {
        value: code,
        label: `${countries.getName(code, 'en')} (${code})`,
      },
      whitelist: [
        {
          marketCountry: [MarketCountryCode.Finland, MarketCountryCode.Norway],
        },
      ],
    })),
];

export const useCitizenshipOptions = () =>
  useApplicationConditionalFilter(unfilteredCitizenshipOptions);
